"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BaseConnectionHealthPolicy_1 = require("./BaseConnectionHealthPolicy");
var UnusableAudioWarningConnectionHealthPolicy = /*#__PURE__*/function (_BaseConnectionHealth) {
  _inherits(UnusableAudioWarningConnectionHealthPolicy, _BaseConnectionHealth);
  function UnusableAudioWarningConnectionHealthPolicy(configuration, data) {
    var _this;
    _classCallCheck(this, UnusableAudioWarningConnectionHealthPolicy);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnusableAudioWarningConnectionHealthPolicy).call(this, configuration, data));
    _this.coolDownTimeMs = configuration.cooldownTimeMs;
    _this.pastSamplesToConsider = configuration.pastSamplesToConsider;
    _this.fractionalLoss = configuration.fractionalLoss;
    _this.packetsExpected = configuration.packetsExpected;
    _this.maximumTimesToWarn = configuration.maximumTimesToWarn;
    _this.lastWarnTimestampMs = 0;
    _this.warnCount = 0;
    return _this;
  }
  _createClass(UnusableAudioWarningConnectionHealthPolicy, [{
    key: "calculateFractionalLoss",
    value: function calculateFractionalLoss() {
      if (this.currentData.packetsReceivedInLastMinute.length < this.pastSamplesToConsider) {
        return 0;
      }
      var samplesToConsider = this.pastSamplesToConsider;
      var totalPacketsExpected = samplesToConsider * this.packetsExpected;
      var totalPacketsReceived = 0;
      for (var i = 0; i < samplesToConsider; i++) {
        totalPacketsReceived += this.currentData.packetsReceivedInLastMinute[i];
      }
      return Math.min(Math.max(1 - totalPacketsReceived / totalPacketsExpected, 0), 1);
    }
  }, {
    key: "health",
    value: function health() {
      var warnedRecently = Date.now() - this.lastWarnTimestampMs < this.coolDownTimeMs;
      if (warnedRecently) {
        return this.currentHealth;
      }
      var hasHadHighPacketLoss = this.calculateFractionalLoss() >= this.fractionalLoss;
      if (hasHadHighPacketLoss) {
        if (this.currentHealth !== 0) {
          this.lastWarnTimestampMs = Date.now();
          this.warnCount++;
          if (this.warnCount > this.maximumTimesToWarn) {
            return 1;
          }
        }
        return 0;
      }
      return 1;
    }
  }]);
  return UnusableAudioWarningConnectionHealthPolicy;
}(BaseConnectionHealthPolicy_1.default);
exports.default = UnusableAudioWarningConnectionHealthPolicy;